import React, { Component } from "react";
import ListingPage from "../2/Controls/ListingPage";
import Window from "../2/Controls/Window";
import AddEditProductTax from "./AddEditProductTax";

class TaxesList extends Component {

  constructor(props) {
    super(props);

    this.state = {
      list: [],
      totalCount: 0,
      loading: false,

      page: 1,
      pageSize: 25,

      filter: {
        status: "",
        name: ""
      },

      showAddTaxes: false,
      selectedRow: null,
      showDeleteModal: false
    };

    this.listPageSettings = {

      Title: "Taxes",

      Search: {
        showSearch: false
      },

      HeaderButtons: [
        {
          ButtonType: "Button",
          Type: "primary",
          Text: "New",
          Icon: "add",
          Action: "popup"
        }
      ],

   Columns: [

  {
    Name: "Tax Group",
    Type: "field",
    ShowInMobile: true,
    Columns: [{ Column: "TaxGroup" }, { Column: "TaxesDisplay" }]
  },

  {
    Name: "Tax Group",
    Type: "field",
    Columns: [{ Column: "TaxGroup" }]
  },

  {
    Name: "Taxes",
    Type: "field",
    Columns: [{ Column: "TaxesDisplay" }]
  }

],

      RowButtons: [

        {
          ButtonType: "ImageButton",
          Type: "edit",
          Icon: "edit",
          Action: "popup"
        },

        {
          ButtonType: "ImageButton",
          Type: "delete",
          Icon: "delete",
          Action: "delete"
        }

      ],

      Sort: [
        {
          Column: "ActionOn",
          Order: "desc"
        }
      ]

    };

  }


  componentDidMount() {
    this.loadData();
  }


 loadData = async () => {

  this.setState({ loading: true });

  try {

    const res = await this.props.getProductTaxes();

    let list = [];
    let totalCount = 0;

    if (res && res.hasOwnProperty("length")) {

      list = res.map(item => ({

        ...item,

        TaxesDisplay: item.Taxes
          ? item.Taxes
              .map(t => `${t.TaxName} (${t.TaxPercentage}%)`)
              .join(", ")
          : ""

      }));

      totalCount = list.length;
    }

    this.setState({
      list,
      totalCount,
      loading: false
    });

  }
  catch (error) {

    console.error(error);

    this.setState({
      loading: false
    });

  }

};

  onNextClick = () => {

    const totalPages = Math.ceil(
      this.state.totalCount / this.state.pageSize
    );

    if (this.state.page < totalPages) {

      this.setState(
        prev => ({
          page: prev.page + 1
        }),
        this.loadData
      );

    }

  };


  onPreviousClick = () => {

    if (this.state.page > 1) {

      this.setState(
        prev => ({
          page: prev.page - 1
        }),
        this.loadData
      );

    }

  };


  onFirstClick = () => {

    this.setState(
      { page: 1 },
      this.loadData
    );

  };


  onLastClick = () => {

    const totalPages = Math.ceil(
      this.state.totalCount / this.state.pageSize
    );

    this.setState(
      { page: totalPages },
      this.loadData
    );

  };


  onRecordsPerPageCountChange = (pageSize) => {

    this.setState(
      {
        pageSize: Number(pageSize),
        page: 1
      },
      this.loadData
    );

  };


  onHeaderButtonClicked = (btn) => {

    if (btn.Action === "popup") {

      this.setState({
        showAddTaxes: true,
        selectedRow: null
      });

    }

  };


  onRowButtonClicked = (btn, row) => {

    if (btn.Action === "popup") {

      this.setState({
        showAddTaxes: true,
        selectedRow: row
      });

    }

    if (btn.Action === "delete") {

      this.setState({
        showDeleteModal: true,
        selectedRow: row
      });

    }

  };


  deleteRecord = async () => {

    const success = await this.props.deleteProductTax(
      this.state.selectedRow.key
    );

    if (success) {

      this.setState({
        showDeleteModal: false,
        selectedRow: null
      },
      this.loadData);

    }

  };


  onPostPopupSave = () => {

    this.setState({
      showAddTaxes: false,
      selectedRow: null
    },
    this.loadData);

  };


  onClosePopup = () => {

    this.setState({
      showAddTaxes: false,
      selectedRow: null
    });

  };

  onPageChange = (page, pageSize) => {
  console.log("page",page);
  this.setState(
    { page, pageSize },
    () => {
      this.loadData();
    }
  );
};


  render() {

    return (

      <>

        <ListingPage
           {...this.props} 
           onPageChange={this.onPageChange}
          listPageSettings={this.listPageSettings}

          list={this.state.list}

          loading={this.state.loading}

          totalItemsCount={this.state.totalCount}

          recordFrom={(this.state.page - 1) * this.state.pageSize}

          itemsCountPerPage={this.state.pageSize}

          onNextClick={this.onNextClick}

          onPreviousClick={this.onPreviousClick}

          onFirstClick={this.onFirstClick}

          onLastClick={this.onLastClick}

          onRecordsPerPageCountChange={this.onRecordsPerPageCountChange}

          onHeaderButtonClicked={this.onHeaderButtonClicked}

          onRowButtonClicked={this.onRowButtonClicked}

        />


        {this.state.showAddTaxes && (

          <AddEditProductTax
            {...this.props}
            productTax={this.state.selectedRow}
            onSave={this.onPostPopupSave}
            onClose={this.onClosePopup}
          />

        )}


        {this.state.showDeleteModal && (

          <Window

            header="Delete"

            size="medium"

            modal={true}

            onClose={() =>
              this.setState({
                showDeleteModal: false
              })
            }

            onButtonClick={(btn) => {

              if (btn.toLowerCase() === "yes") {
                this.deleteRecord();
              }
              else {

                this.setState({
                  showDeleteModal: false,
                  selectedRow: null
                });

              }

            }}

            buttons={[

              {
                Type: "secondary",
                Text: "No",
                Align: "left"
              },

              {
                Type: "primary",
                Text: "Yes",
                Align: "right"
              }

            ]}

          >

            Are you sure you want to delete this Tax?

          </Window>

        )}

      </>

    );

  }

}

export default TaxesList;